
    <table datatable class="mb-0 table align-middle effects-table"
        [ngClass]="{'hidden': embedded && (showBotBuilder || showDeterminantBuilder || showBotEdit)}">
        <thead *ngIf="showTableheader">
            <tr>
                <th class="text-center cell-order">&nbsp;</th>
                <th>{{'Determinant' | translate}}</th>
                <th>{{'Action' | translate}}</th>
                <th class="text-center cell-delete">&nbsp;</th>
            </tr>
            <tr class="separator-header"><th colspan="4"></th></tr>
        </thead>
        <tbody
            cdkDropList
            [cdkDropListData]="componentAction.actions"
            (cdkDropListDropped)="dropped($event)">
            <tr cdkDrag *ngFor="let action of componentAction.actions; let i=index;" class="bots-loop bot-{{ action.bots.length ? action.bots[0].botType : ''}}">
                <td class="text-center align-middle handlers-cell">
                    <i cdkDragHandle class="fa-solid fa-grip-dots handle mx-1" style="font-size:0.8rem"></i>
                </td>
                <td>
                    <div (click)="openDeterminantModal(action)">
                        <determinant-query-readonly *ngIf="!isDeterminantEmpty(action.jsonDeterminants)"
                                                    [jsonDeterminants]="action.jsonDeterminants"
                                                    [determinantMapById]="determinantMapById"
                        ></determinant-query-readonly>
                        <div class="workarea__draghere" *ngIf="isDeterminantEmpty(action.jsonDeterminants)">
                            <div class="editBtn light text-dark">{{'Select' | translate}}</div>
                        </div>
                    </div>
                </td>
                <td *ngIf="!isBotEmpty(action.bots)">
                    <div class="d-flex align-items-center" *ngFor="let bot of action.bots; let j=index;">
                        <span class="d-flex flex-shrink-1 mr-2 item-and-or" *ngIf="j > 0"> + </span>
                        <div *ngIf="!isBotEmpty(action.bots)" class="editBtn light text-dark">
                            <span (click)="openBotBuilder(action)">
                                {{ bot.name }} - 
                                <b *ngIf="bot.botType === 'document'">{{'bots.documentBot' | translate}}</b>
                                <b *ngIf="bot.botType === 'system'">{{'bots.systemBot' | translate}}</b>
                                <b *ngIf="bot.botType === 'data'">{{'bots.dataBot' | translate}}</b>
                                <b *ngIf="bot.botType === 'internal'">{{'bots.internalBot' | translate}}</b>
                                <b *ngIf="bot.botType === 'message'">{{'bots.messageBot' | translate}}</b>
                            </span>
                            <i *ngIf="bot.botType !== 'system'" (click)="directEditBot(bot);" tooltip="{{'Bot mapping' | translate}}" class="fal fa-exchange ml-2"></i>
                        </div>
                        <div class="d-flex align-items-center ml-2" *ngIf="bot.botType !== 'system'">
                            <span class="multiple-bot mr-2" placement="left" tooltip="{{'Is bot multiple' | translate}}" (click)="toggleMultipleRole(action)">
                                <i class="fas {{action?.multipleBot ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"></i>
                            </span>
                            <span *ngIf="action.multipleBot"
                                  class="d-inline-flex align-items-center field-trigger">
                                <span *ngIf="getMultipleFieldLeafName(action) as leaf"
                                      class="badge badge-light border px-2 py-1 field-trigger__chip"
                                      [popover]="fieldsPopover"
                                      placement="left"
                                      popoverTitle="{{ 'Select grid' | translate }}"
                                      containerClass="confirmation-popover field-tree-popover"
                                      triggers="click"
                                      [outsideClick]="true">
                                    <span class="field-trigger__chip-label"
                                          [tooltip]="getMultipleFieldName(action)"
                                          placement="top">
                                        <i class="fal fa-th mr-1"></i>{{ leaf }}
                                    </span>
                                    <i class="fal fa-times ml-1 cursor-pointer"
                                       (click)="onMultipleFieldChange(action, null); $event.stopPropagation();"
                                       tooltip="{{ 'Reset multiple field' | translate }}"
                                       placement="top"></i>
                                </span>
                                <button *ngIf="!action.multipleFieldKey"
                                        type="button"
                                        class="btn-circle-icon btn-circle-small btn-warning"
                                        [popover]="fieldsPopover"
                                        placement="left"
                                        popoverTitle="{{ 'Select grid' | translate }}"
                                        containerClass="confirmation-popover field-tree-popover"
                                        triggers="click"
                                        [outsideClick]="true">
                                    <i class="fal fa-th"
                                       [tooltip]="'No grid selected — pick the field this bot iterates over' | translate"
                                       placement="top"></i>
                                </button>
                                <ng-template #fieldsPopover>
                                    <field-tree-picker
                                        [items]="allComponentsTree"
                                        [selectedKey]="action.multipleFieldKey"
                                        [selectableTypes]="['datagrid','editgrid']"
                                        placeholder="Search a field"
                                        emptyMessage="No fields available"
                                        (selectionChange)="onMultipleFieldChange(action, $event)"></field-tree-picker>
                                </ng-template>
                            </span>
                        </div>
                        <!-- Target tab selector (inline, same row as bot label) -->
                        <div class="d-flex align-items-center p-0 ml-2" *ngIf="bot.botType === 'system' && isTabNavigationAction(action) && tabsFields.length > 1">
                            <span *ngIf="getTargetTabName(action)" class="badge badge-light border px-2 py-1 mr-1" style="font-size: 0.75rem;">
                                <i class="fal fa-bullseye-arrow mr-1"></i>{{ getTargetTabName(action) }}
                                <i class="fal fa-times ml-1 cursor-pointer" (click)="clearTargetTab(action); $event.stopPropagation();"
                                   tooltip="{{'Reset to nearest parent tab' | translate}}" placement="top"></i>
                            </span>
                            <i class="fal fa-bullseye-arrow mr-2 cursor-pointer"
                                [class.text-muted]="!getTargetTabName(action)"
                                [class.text-primary]="getTargetTabName(action)"
                                [popover]="targetTabPopover"
                                placement="left"
                                popoverTitle="{{ 'Target tab' | translate }}"
                                containerClass="confirmation-popover"
                                triggers="click"
                                [outsideClick]="true"></i>
                            <ng-template #targetTabPopover>
                                <div class="popover-buttons">
                                    <select class="form-control"
                                            [(ngModel)]="action.targetTabComponentKey"
                                            (change)="tmpAction = null; selectedAction = null; saveActionComponent()">
                                        <option [ngValue]="null">{{'Nearest parent tab (default)' | translate}}</option>
                                        <option *ngFor="let tab of tabsFields"
                                                [value]="tab.key">{{ tab.name || tab.key }}</option>
                                    </select>
                                </div>
                            </ng-template>
                        </div>
                        <!-- Target element selector for scrollToElement (TOBE-17801) -->
                        <div class="d-flex align-items-center ml-2 field-trigger"
                             *ngIf="bot.botType === 'system' && isScrollToElementAction(action)">
                            <span *ngIf="getTargetElementLeafName(action) as leaf"
                                  class="badge badge-light border px-2 py-1 field-trigger__chip"
                                  [popover]="targetElementPopover"
                                  placement="left"
                                  popoverTitle="{{ 'Target element' | translate }}"
                                  containerClass="confirmation-popover field-tree-popover"
                                  triggers="click"
                                  [outsideClick]="true">
                                <span class="field-trigger__chip-label"
                                      [tooltip]="getTargetElementName(action)"
                                      placement="top">
                                    <i class="fal fa-crosshairs mr-1"></i>{{ leaf }}
                                </span>
                                <i class="fal fa-times ml-1 cursor-pointer"
                                   (click)="onTargetElementChange(action, null); $event.stopPropagation();"
                                   tooltip="{{ 'Reset target element' | translate }}"
                                   placement="top"></i>
                            </span>
                            <button *ngIf="!action.targetElementKey"
                                    type="button"
                                    class="btn-circle-icon btn-circle-small btn-warning"
                                    [popover]="targetElementPopover"
                                    placement="left"
                                    popoverTitle="{{ 'Target element' | translate }}"
                                    containerClass="confirmation-popover field-tree-popover"
                                    triggers="click"
                                    [outsideClick]="true">
                                <i class="fal fa-crosshairs"
                                   [tooltip]="'No element selected — pick the target the button scrolls to' | translate"
                                   placement="top"></i>
                            </button>
                            <ng-template #targetElementPopover>
                                <field-tree-picker
                                    [items]="currentFormTree"
                                    [selectedKey]="action.targetElementKey"
                                    placeholder="Search a field"
                                    emptyMessage="No fields available"
                                    (selectionChange)="onTargetElementChange(action, $event)"></field-tree-picker>
                            </ng-template>
                        </div>
                        <!-- Destination tab selector for goToTab (TOBE-17942) -->
                        <div class="d-flex align-items-center p-0 ml-2"
                             *ngIf="bot.botType === 'system' && isGoToTabAction(action)">
                            <span *ngIf="getDestinationTabName(action)" class="badge badge-light border px-2 py-1 mr-1" style="font-size: 0.75rem;">
                                <i class="fal fa-bullseye-arrow mr-1"></i>{{ getDestinationTabName(action) }}
                                <i class="fal fa-times ml-1 cursor-pointer"
                                   (click)="onDestinationTabChange(action, null); $event.stopPropagation();"
                                   tooltip="{{'Reset destination tab' | translate}}" placement="top"></i>
                            </span>
                            <i *ngIf="action.destinationTabKey"
                               class="fal fa-bullseye-arrow mr-2 cursor-pointer text-primary"
                               [popover]="destinationTabPopover"
                               placement="left"
                               popoverTitle="{{ 'Destination tab' | translate }}"
                               containerClass="confirmation-popover"
                               triggers="click"
                               [outsideClick]="true"></i>
                            <button *ngIf="!action.destinationTabKey"
                                    type="button"
                                    class="btn-circle-icon btn-circle-small btn-warning"
                                    [popover]="destinationTabPopover"
                                    placement="left"
                                    popoverTitle="{{ 'Destination tab' | translate }}"
                                    containerClass="confirmation-popover"
                                    triggers="click"
                                    [outsideClick]="true">
                                <i class="fal fa-bullseye-arrow"
                                   [tooltip]="'No tab selected — pick the tab this button navigates to' | translate"
                                   placement="top"></i>
                            </button>
                            <ng-template #destinationTabPopover>
                                <div class="popover-buttons">
                                    <select class="form-control"
                                            [ngModel]="action.destinationTabKey"
                                            (ngModelChange)="onDestinationTabChange(action, $event)">
                                        <option [ngValue]="null" disabled>{{'Select a destination tab' | translate}}</option>
                                        <option *ngFor="let pane of tabPanes"
                                                [value]="pane.key">{{ pane.label }}</option>
                                    </select>
                                </div>
                            </ng-template>
                        </div>
                        <!-- Media file picker for downloadFile system action (#95) -->
                        <div class="d-flex align-items-center ml-2 field-trigger"
                             *ngIf="bot.botType === 'system' && isDownloadFileAction(action)">
                            <span *ngIf="action.selectedMediaFileName as fileName"
                                  class="badge badge-light border px-2 py-1 field-trigger__chip"
                                  (click)="openMediaPicker(action)">
                                <span class="field-trigger__chip-label"
                                      [tooltip]="fileName"
                                      placement="top">
                                    <i class="fal fa-file-pdf mr-1"></i>
                                    <span class="field-trigger__chip-text">{{ fileName }}</span>
                                </span>
                                <i class="fal fa-times ml-1 cursor-pointer"
                                   (click)="clearSelectedMediaFile(action); $event.stopPropagation();"
                                   tooltip="{{ 'Reset selected file' | translate }}"
                                   placement="top"></i>
                            </span>
                            <button *ngIf="!action.selectedMediaFileId"
                                    type="button"
                                    class="btn-circle-icon btn-circle-small btn-warning"
                                    (click)="openMediaPicker(action)">
                                <i class="fal fa-file-pdf"
                                   [tooltip]="'No file selected — pick the file the button downloads' | translate"
                                   placement="top"></i>
                            </button>
                        </div>
                    </div>
                </td>
                <td *ngIf="isBotEmpty(action.bots)">
                    <div class="workarea__draghere" (click)="openBotBuilder(action)">
                        <div class="editBtn light text-dark">{{'Click to add bot' | translate}}</div>
                    </div>
                </td>
                <td class="text-center opts-cell">
                    <div class="d-flex align-items-center justify-content-end">
                        <!--
                        <span *ngIf="showSystemBots" class="parallel-bot mr-2" placement="left" tooltip="{{'Parallel to previous if checked' | translate}}" (click)="toggleParallelRole(action)">
                            <i class="ml-2 fas {{action?.parallel ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}" style="position:relative;top:2px;inset-inline-start:-4px;"></i>
                        </span>
                        <span class="parallel-bot mr-2" placement="left" tooltip="{{'Mandatory - will be passed even if previous rows failed' | translate}}" (click)="toggleMandatoryRole(action)">
                            <i class="ml-2 fas {{action?.mandatory ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}" style="position:relative;top:2px;inset-inline-start:-4px;"></i>
                        </span>
                        -->
                        <div class="editBtn light text-dark p-0 ml-auto" *ngIf="i > 0">
                            <span *ngIf="showSystemBots" class="parallel-bot ml-1" placement="left" tooltip="{{'Parallel to previous if checked' | translate}}" (click)="toggleParallelRole(action)">
                                <i class="ml-2 fas {{action?.parallel ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}" style="position:relative;inset-inline-start:-4px;"></i>
                            </span>
                            <span class="parallel-bot mr-2" placement="left" tooltip="{{'Mandatory - will be passed even if previous rows failed' | translate}}" (click)="toggleMandatoryRole(action)">
                                <i class="ml-2 fas {{action?.mandatory ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}" style="position:relative;"></i>
                            </span>
                        </div>
                        <i class="fas fa-times btn-xs btn-bordered btn-danger btn-icon false mx-2" (click)="removeActionRow(i)"></i>
                    </div>
                </td>
            </tr>
            <tr class="separator-row" *ngIf="componentAction?.actions?.length"><td colspan="4"></td></tr>
            <tr class="placeholder-row">
                <td></td>
                <td>
                    <div (click)="openDeterminantModal(null); isNew = true;">
                        <div class="workarea__draghere">
                            <div class="editBtn light text-dark">{{'Select' | translate}}</div>
                        </div>
                    </div>
                </td>
                <td>
                    <div (click)="openBotBuilder(null); isNew = true;">
                        <div class="workarea__draghere">
                            <div class="editBtn light text-dark">{{'Click to add bot' | translate}}</div>
                        </div>
                    </div>
                </td>
                <td class="text-right"></td>
            </tr>
        </tbody>
    </table>

    <drawer [title]="'Apply determinant'"
        [showHeader]="showDrawerHeader"
        [isClosed]="!showDeterminantBuilder"
        [noContentPadding]="!embedded"
        (saveEvent)="updateDeterminant($event)"
        [embedded]="embedded" (closeEvent)="closeLayer();"
        [contextLabel]="contextLabel"
        class="text-left in-modal-drawer">
        <div class="drawer-content drawer-direct-content">
            <determinant-manager
                *ngIf="serviceId && tmpAction"
                [serviceId]="serviceId"
                [embedded]="embedded"
                [determinantMapById]="determinantMapById"
                [jsonString]="tmpAction.jsonDeterminants"
                (builderUpdated)="temoupdateDeterminant($event)"
                [showBuilder]=true
                (cancel)="closeLayer()"
                (updateHeader)="showModalHeader($event)"
                class="d-flex overflow-hidden mh-100 h-100 w-100">
            </determinant-manager>
        </div>
    </drawer>
    
    <drawer [title]="'Apply bot'"
        [showHeader]="showDrawerHeader"
        [isClosed]="!showBotBuilder"
        (saveEvent)="saveActionComponent()"
        [noContentPadding]="!embedded"
        [embedded]="embedded"
        (closeEvent)="closeLayer();"
        [showHeaderButtons]="false"
        [contextLabel]="contextLabel"
        [noContentPadding]="true"
        class="text-left in-modal-drawer">
            <action-builder class="drawer-content d-flex flex-column"
            [serviceBots]="serviceBots"
            [tmpAction]="tmpAction"
            [stickyScrolling]="stickyScrolling"
            (updateAction)="updateBots($event)"
            (openNewModal)="openAddModal()"
            (openEditionModal)="directEditBot($event)"
            (deleteBot)="onDeleteBot($event)"
            (cancelEdition)="closeLayer()"
            (saveAction)="saveActionComponent();closeLayer()"></action-builder>
    </drawer>
<!--
<div class="row layer mt-0 in-tab-layer container-fluid" id="detFromFormio"
    [ngClass]="{'sub-layer-active': showDeterminantBuilder, 'hidden': !showDeterminantBuilder}" *ngIf="showDeterminantBuilder">
    <layer-header (closeLayer)="closeLayer()" (setListView)="setListView($event)" [listToggle]="listToggle"
        [listIcons]=false title="{{'Apply determinant' | translate}}" [customClass]="'mt-0'" *ngIf="store.state.common.determinantSection.topLayer !== 'edit'">
        <ng-content></ng-content>
    </layer-header>
    <determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
        class="layer onTop-sub-layer" id="newDetFromFormio" [serviceId]="serviceId" [isOnSubLayer]="true"
        [determinant]="store.state.common.determinantSection.determinant" (formSubmit)="closeEdit()"
        (editCancel)="closeEdit()"></determinant-new>
    <div class="row {{store.state.common.determinantSection.topLayer === 'edit' ? 'hidden' : ''}}">
        <div class="col-12">
            <div class="row">
                <determinant-builder-new [serviceId]="serviceId" [jsonString]="tmpAction.jsonDeterminants"
                                         [determinantMapById]="determinantMapById"
                                         (onSave)="updateDeterminant($event);closeLayer()"
                                         (onChange)="tmpAction.jsonDeterminants = $event"
                                         (onCancel)="closeLayer()" class="col-12">
                </determinant-builder-new>
            </div>
        </div>
    </div>
</div>


<div *ngIf="!showBotAdd && !showBotEdit && showBotBuilder" id="botFromFormio" class="row layer mt-0 in-tab-layer container-fluid" [ngClass]="{'sub-layer-active': showBotBuilder, 'hidden': !showBotBuilder}">
    <layer-header (closeLayer)="closeLayer()" [listIcons]="false" [customClass]="'mt-0'" title="{{'Apply bot' | translate}}">
        <ng-content></ng-content>
    </layer-header>
    <div class="row">
        <div class="col">
           <action-builder
            [serviceBots]="serviceBots"
            [tmpAction]="tmpAction"
            [stickyScrolling]="stickyScrolling"
            (updateAction)="updateBots($event)"
            (openNewModal)="openAddModal()"
            (openEditionModal)="directEditBot($event)"
            (cancelEdition)="closeLayer()"
            (saveAction)="saveActionComponent();closeLayer()"></action-builder>
        </div>
    </div>
</div>
-->

<drawer [title]="'New bot'"
        [showHeader]="true"
        [isClosed]="!showBotAdd"
        [noContentPadding]="!embedded"
        [embedded]="embedded"
        (closeEvent)="closeAddEdit();"
        (saveEvent)="saveNewBot();"
        [contextLabel]="contextLabel"
        class="text-left in-modal-drawer">
        <div class="drawer-content drawer-direct-content">
            <role-bot-manage [serviceId]="serviceId" [showBotAdd]="showBotAdd" (modalAddedEvent)="addedBot()"></role-bot-manage>
        </div>
    </drawer>

<!--
    <app-new-bot #newBotComponent *ngIf="showBotAdd && showBotBuilder"
                class="on-iframe-form"
                id="newBotFromFormio"
                [fromTab]=true
                (modalClosedEvent)="closeAddEdit();"
                (modalAddedEvent)="addedBot();"></app-new-bot>
-->

    <drawer [title]="'Edit bot'"
        [showHeader]="true"
        [isClosed]="!showBotEdit"
        [noContentPadding]="!embedded"
        [embedded]="embedded"
        (closeEvent)="closeAddEdit();"
        (saveEvent)="saveEditBot();"
        (scrollEvent)="onEditBotDrawerScroll();"
        [contextLabel]="contextLabel"
        class="text-left in-modal-drawer">
        <div class="drawer-content drawer-direct-content" (scroll)="onEditBotDrawerScroll()">
            <app-edit-bot #editBotComponent *ngIf="showBotEdit && editBot"
                class="on-iframe-form"
                id="editBotFromFormio"
                (modalClosedEvent)="closeAddEdit();"
                (modalAddedEvent)="addedBot();"
                [activeTab]="(editBot.botType !== 'document' && editBot.botType !== 'message') ? 'bot-service' : 'general'"
                [bot]="editBot"></app-edit-bot>
        </div>
    </drawer>

<div class="fix-forms-bottom"></div>

<!-- Media file picker (#95) — single instance, controlled by mediaPickerOpenFor. -->
<drawer [title]="'Pick a media file'"
        [showHeader]="showDrawerHeader"
        [isClosed]="!mediaPickerOpenFor"
        [showHeaderButtons]="false"
        [noContentPadding]="true"
        [embedded]="embedded"
        (closeEvent)="closeMediaPicker()"
        [contextLabel]="contextLabel"
        class="text-left in-modal-drawer">
    <media-picker class="drawer-content d-flex flex-column"
        [visible]="!!mediaPickerOpenFor"
        [selectedMediaFileId]="mediaPickerOpenFor?.selectedMediaFileId"
        (selected)="onMediaFileSelected(mediaPickerOpenFor, $event)"></media-picker>
</drawer>
